import { collection, query, where, getDocs } from "firebase/firestore";
import { db, auth } from "../../../config/firebase";

export async function getUserBooks() {
  try {
    const userId = auth.currentUser?.uid;
    if (!userId) {
      throw new Error("You must be logged in to view books");
    }

    // Query only books owned by the current user
    const booksQuery = query(
      collection(db, "books"),
      where("userId", "==", userId)
    );

    const snapshot = await getDocs(booksQuery);

    // Load books and get cover image from spread-0
    const books = snapshot.docs.map((doc) => {
      const bookData = doc.data();

      // Find cover image from spread-0 elements (right side)
      const spread0 = bookData.spreads?.["spread-0"];

      // Convert elements object to array if needed
      const elements = spread0?.elements;
      const elementsArray = Array.isArray(elements)
        ? elements
        : Object.values(elements || {});

      const coverElement = elementsArray.find(
        (el) => el.type === "image" && el.position?.x >= 600
      );

      return {
        id: doc.id,
        ...bookData,
        coverImage: coverElement?.src || null,
        createdAt: bookData.createdAt?.toDate?.() || null,
        updatedAt: bookData.updatedAt?.toDate?.() || null,
      };
    });

    // Sort in memory by creation date
    return books.sort((a, b) => {
      const dateA = a.createdAt?.getTime() || 0;
      const dateB = b.createdAt?.getTime() || 0;
      return dateB - dateA;
    });
  } catch (error) {
    console.error("Error fetching user books:", error);
    throw new Error("Failed to load your books. Please try again later.");
  }
}
